
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./component/Home";
import Profile from "./component/Profile";
import About from "./component/About";
import Contact from "./component/Contact";
import Layout from "./component/Layout";
import PrivateRoute from "./component/PrivateRoute";
import CustomerProfile from "./customercd/CustomerProfile";
import Plc from "./customercd/plc";
import Joint from "./customercd/joint";
import PlcCustomer from "./customercd/PlcCustomer";
import { AuthProvider } from "./context/AuthContext";
import JointProfile from "./customercd/JointProfile";
import VerificationSelector from "./customercd/VerificationSelector";
import BranchOption  from "./component/BranchOption";
import TokenErrorPage from "./component/TokenErrorPage";
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
             <Route path="/" element={<VerificationSelector/>} />
            <Route path="/obcustomerProfile" element={<CustomerProfile />} />
            <Route path="/plcProfile" element={<PlcCustomer />} />
           <Route path="/obseed" element={<VerificationSelector />} />
            <Route path="/jointProfile" element={<JointProfile />} />
            <Route path="/errorToken" element={<TokenErrorPage/>} />
            { /* <Route path="/Profile" element={<Profile/>} /> */}
            {/* Protected routes */}
           <Route path="/home" element={<PrivateRoute><BranchOption /></PrivateRoute>} />    
            <Route path="about" element={<PrivateRoute><About /></PrivateRoute>} />
            <Route path="contact" element={<PrivateRoute><Contact /></PrivateRoute>} />  
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}
export default App;
